import styled from 'styled-components';
import Row from '../../ui/gridSystem/Row';

export const RowImagesContainer = styled(Row)``;
